import Image from "next/image";
import { useAppSelector } from "redux-share/hooks";
import { conditions, getRemainingTime, isTouchScreen, efficientSecondsToPersianHMS, unitization } from "helpers";
import { ConditionName, IPlayerCardProps } from "interfaces";
import IMAGES from "../../../../../images/importImages";
import { shallowEqual } from 'react-redux'
import { handleClickVideoCard } from "redux-share/actions";
import dynamic from "next/dynamic";

const LiveIcon = dynamic(() => import("../liveStatus/onlineViewer/liveIcon"));
const Tags = dynamic(() => import("../tags/tags"));
const PlayerCore = dynamic(() => import("../../player-core/playerCore"));

const PlayerCard = ({src, type, width, height, title, titleClassName, tags, date, dateClassName, viewers, viewersClassName, isVideo = false, isComplexDesktop = false, isMultiLive = false, isTagCard = false, duration, onClick, id, userId, commentsCount, star, imdb_rate, status_text, content_type}: IPlayerCardProps) => {

    const { params, details } = useAppSelector(({ videoData: { params, details, isComplexDesktop, isComplexPortrait } }) => ({ params, details, isComplexDesktop, isComplexPortrait }), shallowEqual);
    useAppSelector(({ controller: { isFullScreen } }) => ({ isFullScreen }), shallowEqual);

    const handleDoubleClick = (event: any) => {
        if (id === +params.id!) {
            event.stopPropagation();
            event.preventDefault();
            return undefined
        }
    }

    return (
        <div
            className={`pl-w-full pl-flex pl-overflow-hidden ${id === +params.id! ? "pl-cursor-default" : "pl-cursor-pointer"} ${(isComplexDesktop || conditions(ConditionName.isComplexPortrait) || conditions(ConditionName.isTouchScreenLandscape) || conditions(ConditionName.isFullScreen) || (!conditions(ConditionName.isFullScreen) && !conditions(ConditionName.isParamsPortrait))) && !isTagCard && !isMultiLive ? "pl-flex-row pl-gap-2 pl-items-start pl-h-full" : "pl-flex-col pl-h-full pl-w-full"}`}
            onDoubleClick={handleDoubleClick}
            onClick={(event) => {
                onClick(event);
                if (id !== +params.id! && type !== "playlist") {
                    if (conditions(ConditionName.isFullScreen)) window.location.href = window.location.href.replace(`id=${params.id}`, `id=${id}`).replace(`type=${params.type}`,`type=${type}`);
                    else handleClickVideoCard(String(id), type);
                }
            }}
        >
            <div
                className={`pl-relative pl-flex-none ${(isComplexDesktop || conditions(ConditionName.isComplexPortrait) || conditions(ConditionName.isTouchScreenLandscape) || conditions(ConditionName.isFullScreen) || (!conditions(ConditionName.isFullScreen) && !conditions(ConditionName.isParamsPortrait))) && !isTagCard && !isMultiLive ? "" : "pl-w-full"}`}
            >
                {isVideo ? (
                    <div style={{ width: width, height: height }}>
                        <PlayerCore isMultiLive={Boolean(userId)} />
                    </div>
                ) : (
                    <div
                        className={`${(isComplexDesktop || conditions(ConditionName.isComplexPortrait)) && !isTagCard ? "" : "pl-w-full !pl-aspect-video"}`}
                        style={{ width: width, height: (isComplexDesktop || conditions(ConditionName.isComplexPortrait)) && !isTagCard ? height : "initial" }}
                    >
                        {src ? (
                            <Image
                                src={src}
                                className={`pl-rounded-[4px] pl-w-full pl-h-full`}
                                layout={"fill"}
                                alt={details.title ?? "player-card"}
                            />
                        ) : (
                            <div className="pl-rounded-[4px] pl-w-full pl-aspect-video" style={{ background: `linear-gradient(39deg, rgba(16, 9, 49, 1) 0%, rgba(75, 14, 87, 1) 100%)` }} />
                        )}
                    </div>
                )}
                {
                    !isVideo && type !== "playlist" && id !== +params.id! && (
                        <div className="pl-absolute pl-top-1/2 pl-left-1/2 -pl-translate-x-1/2 -pl-translate-y-1/2 pl-w-6 pl-h-6">
                            <Image
                                src={IMAGES.bigPlay}
                                width={isTouchScreen() ? 56 : 72}
                                height={isTouchScreen() ? 56 : 72}
                                className={`pl-big-play-icon`}
                                alt="big-play-icon"
                            />
                        </div>
                    )
                }
                {type === "playlist" ? (
                    <>
                        <div className="pl-absolute pl-top-1/2 pl-left-1/2 -pl-translate-x-1/2 -pl-translate-y-1/2 pl-flex pl-items-center pl-bg-black/[0.4] pl-rounded-full pl-p-1">
                            <Image src={IMAGES.playList} alt="playList-icon" width={22} height={22} />
                        </div>
                        {
                            !!status_text && <p className={`pl-absolute pl-bottom-0 pl-w-full pl-text-white pl-rounded-b-[4px] pl-bg-main-700/[0.7] pl-text-[14px] pl-font-normal pl-text-center`}>
                                {status_text}</p>
                        }
                    </>
                ) : (
                    <>
                        {type === "live" ? (
                            <div className={`pl-absolute pl-bottom-1 pl-left-1 pl-flex pl-items-center pl-gap-2 pl-px-2 pl-py-1 pl-rounded-[4px] pl-text-white ${type === "live" ? "pl-bg-red-zProgress" : "pl-bg-black/[0.7]"}`}>
                                <LiveIcon isLive={true} />
                                <span className="pl-text-[8px] pl-font-medium">زنده</span>
                            </div>
                        )  
                        : 
                        (
                            <>{!!duration && <div className={`pl-absolute pl-bottom-1 pl-left-1 pl-text-[10px] pl-flex pl-items-center pl-gap-2 pl-px-2 pl-py-1 pl-rounded-[4px] pl-text-white pl-bg-black/[0.7]`}>{efficientSecondsToPersianHMS(Number(duration))}</div>}</>
                        )}
                    </>
                )}
            </div>
            <div
                className={`pl-flex pl-py-1 pl-w-full pl-h-full pl-flex-col pl-gap-0.5 pl-justify-between pl-overflow-hidden ${isMultiLive && "pl-justify-center"}`}>
                {title && (
                    <p
                        className={`${isComplexDesktop ? "pl-text-[10px] pl-font-bold" : (conditions(ConditionName.isComplexPortrait) ? "pl-text-[12px] pl-text-justify pl-font-medium" : "pl-text-[14px] pl-font-medium")} ${isMultiLive && !conditions(ConditionName.isTouchScreenPortrait) ? "pl-text-secondary-200" : "pl-text-secondary-700 dark:pl-text-secondary-200"} pl-two-line pl-leading-[14px] ${titleClassName}`}
                    >
                        {title}
                    </p>
                )}
                {!conditions(ConditionName.isTouchScreenLandscape) && !isMultiLive && tags && <div className="pl-flex pl-flex-1 pl-w-full pl-overflow-auto"><Tags tagId={`${id}`} tags={tags!} /></div>}
                <div className="pl-flex pl-items-end pl-gap-[3px] pl-text-secondary-500 dark:pl-text-secondary-300 pl-text-[8px] pl-font-medium">
                    {(type === "playlist" && content_type === 1) || (type === "vod" && (content_type === 1 || content_type === 0) ) ? (
                        <div className={`pl-flex pl-items-center pl-gap-10 ${!!date ? "pl-justify-between" : "pl-justify-end"} pl-w-full pl-pl-2`}>
                            {!!date && <p className="pl-text-dark-4 pl-text-[9px] pl-font-medium">تولید {date}</p>}
                            {!!imdb_rate && (
                                <div className={`pl-flex pl-items-center pl-bg-warning pl-text-secondary-800 pl-rounded-[8px]`}>
                                    <p className="pl-bg-orange-100/[0.4] pl-rounded-r-[24px] pl-text-[8px] pl-font-extrabold pl-px-1 pl-text-center pl-pt-0.5">IMDB</p>
                                    <p className="pl-text-[8px] pl-font-bold pl-pl-[7px] pl-pr-1 pl-text-center pl-pt-0.5">{imdb_rate}</p>
                                </div>
                            )}
                        </div>
                    ) : (
                        <>
                            {date && <p className={dateClassName}>{getRemainingTime(date)}</p>}
                            {!!viewers && (
                                <>
                                    <span>.</span>
                                    <div className={`pl-flex pl-items-center pl-gap-1 ${viewersClassName}`}>
                                        <div
                                            className="pl-flex pl-items-center pl-gap-0.5 pl-text-secondary-500 dark:pl-text-secondary-300 pl-relative pl-top-[1px]">
                                            <div>{unitization(viewers!).unit}</div>
                                            <div>{unitization(viewers!).value}</div>
                                        </div>
                                        {type === "live" ? <p>نفر در حال تماشا</p> : <p>بازدید</p>}
                                    </div>
                                </>
                            )}
                            {!!commentsCount && (
                                <>
                                    <span>.</span>
                                    <div className="pl-flex pl-items-center pl-gap-1">
                                        <div
                                            className="pl-flex pl-items-center pl-gap-0.5 pl-text-secondary-500 dark:pl-text-secondary-300 pl-relative pl-top-[1px]">
                                            <div>{unitization(commentsCount).unit}</div>
                                            <div>{unitization(commentsCount).value}</div>
                                        </div>
                                        <p>دیدگاه</p>
                                    </div>
                                </>
                            )}
                            {!!star && (
                                <>
                                    <span>.</span>
                                    <div className="pl-flex pl-items-center pl-gap-1">
                                        <Image src={IMAGES.starSlash} className="!pl-mb-[1px]" width={12} height={12} />
                                        <p>{star}</p>
                                    </div>
                                </>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    )
}

export default PlayerCard;